<template>
  <div class="row">
    <div class="col-xl-12">
      <div class="kt-portlet kt-portlet--mobile">
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="kt-font-brand flaticon2-shield"></i>
            </span>
            <h3 class="kt-portlet__head-title">บทบาท</h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit">
            <div class="row">
              <div class="col-xl-12">
                <div class="form-group">
                  <label>คำค้นหา:</label>
                  <input
                    v-model="keyword"
                    type="text"
                    class="form-control"
                    placeholder="ค้นหาจาก ชื่อบทบาท คำอธิบาย"
                  />
                </div>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button type="reset" class="btn btn-secondary" @click="formReset">ล้างค่าทั้งหมด</button>
              </div>
              <div class="col-xl-6 text-right">
                <router-link
                  to="Roles/Add"
                  tag="button"
                  title="เพิ่มข้อมูลบทบาท"
                  class="btn btn-outline-brand"
                  v-if="this.$root.canShow(['MANAGE_MASTER', 'MASTER_ROLE'])"
                >
                  <i class="fa fa-plus-circle"></i> เพิ่มข้อมูลบทบาท
                </router-link>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="roleTable"
              >
                <thead>
                  <tr>
                    <th>ชื่อบทบาท</th>
                    <th>คำอธิบาย</th>
                    <th>จำนวนสมาชิก</th>
                    <th>คำสั่ง</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>

    <!-- begin: Single Modal -->
    <router-view />
    <!-- end: Single Modal -->
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import router from "../../../router";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

let RoleActions = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="edit" v-if="data.showEditButton" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="แก้ไขข้อมูลบทบาท">
      <i class="la la-edit"></i>
    </a>
    <a href="#" @click.prevent="remove" v-if="data.showDeleteButton" class="btn btn-sm btn-clean btn-icon btn-icon-md" title="ลบข้อมูลบทบาท">
      <i class="la la-trash"></i>
    </a>
  </div>`,
  methods: {
    edit: function() {
      router.push({ path: `/Master/Roles/Edit/${this.data.roleName}` });
    },
    remove: function() {
      let self = this;

      Swal.fire({
        title: "คำสั่งลบบทบาท",
        type: "warning",
        html:
          "กรุณายืนยันคำสั่งลบบทบาท <strong>" +
          this.data.roleName +
          "</strong> หลังจากลบแล้วจะส่งผลให้สมาชิกที่เข้าระบบใหม่ไม่สามารถใช้งานบทบาทนี้ได้อีก",
        input: this.data.userCount > 0 ? "checkbox" : "",
        inputValue: 0,
        inputPlaceholder: "ต้องการลบบทบาทออกจากข้อมูลสมาชิกด้วย",
        showCancelButton: true,
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
        showLoaderOnConfirm: true
      }).then(result => {
        if (result.value === 0 || result.value === 1) {
          KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังลบข้อมูล กรุณารอสักครู่..."
          });

          axios
            .post("/Api/Roles/Delete", {
              roleName: this.data.roleName,
              force: result.value === 1
            })
            .then(function(response) {
              if (response.data.status) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", response.data.message, "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  error.response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
        }
      });
    }
  }
});

export default {
  data: function() {
    return {
      keyword: ""
    };
  },
  methods: {
    formReset: function(e) {
      this.keyword = "";
      this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#roleTable").DataTable();
      table.search(this.keyword);
      table.draw();
    },
    reloadDataTable: function(resetPaging = false) {
      $("#roleTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    }
  },
  async mounted() {
    let self = this;
    const user = await this.$root.getUser();
    var table = $("#roleTable");

    // begin first table
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,

        ajax: {
          url: "/Api/Roles/Find",
          type: "post",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          }
        },

        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
      <'row'<'col-sm-12'tr>>
			<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

        lengthMenu: [50, 100, 200, 500],

        pageLength: 100,

        language: {
          lengthMenu: "Display _MENU_"
        },

        // Order settings
        order: [[1, "desc"]],
        columns: [
          { data: "roleName", width: "20%" },
          { data: "description" },
          {
            data: "userCount",
            className: "text-center",
            width: "10%",
            render: function(data, type, full, meta) {
              return data;
            }
          },
          {
            data: "roleName",
            className: "text-center",
            width: "10%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            }
          }
        ]
      })
      .on("draw.dt", function() {
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();
          var data = $dt.row($tr).data();
          if (data) {
            data.showEditButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MASTER_ROLE"
            ]);
            data.showDeleteButton = self.$root.canShow([
              "MANAGE_MASTER",
              "MASTER_ROLE"
            ]);
            new RoleActions({ data: { data }, parent: self }).$mount(el);
          }
        });
      });
  }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// App/Components/Master/Role/RoleList.vue